import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { set_user } from './appSlice';

type Entry = { data?: unknown; requestId: string };
type Request = { ownerId: string | null; key: string; requestId: string };
export type BillingCacheState = { ownerId: string | null; entries: Record<string, Entry> };
const initialState: BillingCacheState = { ownerId: null, entries: {} };

// Session-only: keep responses across navigation, never persist private billing
// history to disk. Each resource key includes its API endpoint and filters.
const slice = createSlice({
  name: 'billingCache',
  initialState,
  reducers: {
    billingRequestStarted(state, { payload }: PayloadAction<Request>) {
      if (payload.ownerId !== state.ownerId) return;
      const previous = state.entries[payload.key];
      // Reinsert for bounded, most-recently-used eviction.
      delete state.entries[payload.key];
      state.entries[payload.key] = { ...previous, requestId: payload.requestId };
      for (const key of Object.keys(state.entries).slice(0, -32)) delete state.entries[key];
    },
    billingResponseReceived(state, { payload }: PayloadAction<Request & { data: unknown }>) {
      if (payload.ownerId !== state.ownerId) return;
      const entry = state.entries[payload.key];
      // A late response must not replace a newer refresh or another account.
      if (entry?.requestId === payload.requestId) entry.data = payload.data;
    },
  },
  extraReducers: builder => {
    builder.addCase(set_user, (state, { payload }) => {
      const ownerId = payload.userId || null;
      if (ownerId !== state.ownerId || !ownerId) return { ownerId, entries: {} };
    });
  },
});

export const { billingRequestStarted, billingResponseReceived } = slice.actions;
export default slice.reducer;
